export enum ProfileTarget {
  Advertiser = 'advertiser',
  Webmaster = 'webmaster',
}
